import FOSRouting from 'FOSRouting';
import FOSRoutingJSON from 'FOSRoutingJSON';

FOSRouting.setRoutingData(FOSRoutingJSON);

export default FOSRouting;
